import Em from 'ember';
import { later } from '@ember/runloop';

// The contents of this lib file have been inlined from https://github.com/GavinJoyce/ember-backoff
// so that we can drop the dependency on this unmaintained addon using deprecated ember dependencies

// https://github.com/GavinJoyce/ember-backoff/blob/35e563e023092d97fd4877e155fd7bdd86975d67/addon/delay.js
function delay(milliseconds) {
  if (milliseconds === undefined) {
    milliseconds = 2000;
  }
  return new Em.RSVP.Promise(function (resolve) {
    later(this, resolve, milliseconds);
  });
}

// https://github.com/GavinJoyce/ember-backoff/blob/35e563e023092d97fd4877e155fd7bdd86975d67/addon/strategy/exponential.js
function exponentialStrategy(initialWait, retryCount) {
  return Math.pow(2, retryCount) * initialWait;
}

// https://github.com/GavinJoyce/ember-backoff/blob/35e563e023092d97fd4877e155fd7bdd86975d67/addon/retry-with-backoff.js
export function retryWithBackoff(callback, retryCountBeforeFailure, initialWaitInMilliseconds, backoffStrategy) {
  retryCountBeforeFailure = retryCountBeforeFailure || 5;
  initialWaitInMilliseconds = initialWaitInMilliseconds || 250;
  backoffStrategy = backoffStrategy || exponentialStrategy;
  let _retryWithCallback = function (callback, retryCount) {
    return callback().catch(function (reason) {
      if (retryCount < retryCountBeforeFailure) {
        return delay(backoffStrategy(initialWaitInMilliseconds, retryCount)).then(function () {
          return _retryWithCallback(callback, ++retryCount);
        });
      }
      throw reason;
    });
  };
  return _retryWithCallback(callback, 0);
}